import r from "moment";
import a from "./getOutletTodayOpeningTimes.mjs";
import "../_baseIteratee-4c4d0995.mjs";
import "../_getTag-4e44633b.mjs";
import "../isArray-0d9c7aaa.mjs";
import "../_baseIsEqual-12d01a44.mjs";
import "../identity-6eafe87b.mjs";
import "../toString-3b91b335.mjs";
import "../noop-378485d5.mjs";
import "./getListOutletOpeningHoursTable.mjs";
import "@ancon/wildcat-types";
import "../shared/isWithinFlag.mjs";
import "../shared/generateId.mjs";
import "react";
import "../time/getTimeSpanParts.mjs";
import "../date/createLocalTimezoneMoment.mjs";
import "../date/convertToLocalTimezone.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
function I(n, s) {
  const p = r(), i = a(n);
  if (i) {
    const o = i.reduce((t, e) => {
      const d = r(e.start), m = r(e.end);
      return p.isBetween(d, m) && (!t || m.isAfter(r(t.end))) ? e : t;
    }, void 0);
    if (o) {
      const t = r(o.end).calendar({
        sameDay: "LT",
        sameElse: "ddd LT"
      });
      return s("untilTime", { time: t }) || "";
    }
  }
}
export {
  I as default
};
